import React, { useEffect, useState } from 'react';
import { getForms } from '../../../actions/formActions';
import { listAlertTrades } from '../../../actions/adminActions';
import { useSelector, useDispatch } from 'react-redux';
import Listing from '../../../components/Common/Listing/Listing';
import _ from 'lodash'

const AlertTrade = () => {
    const listFormKey = "admin_alert_trade_list_form";
    const dispatch = useDispatch();
    const adminState = useSelector((state) => state.admin);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const listForm = formJson[listFormKey];
    const { tradeAlertList = {} } = adminState;
    const [fetchingList, setFetchingList] = useState(true);
    const { headers = [], data: listData = [], meta = {} } = tradeAlertList;

    useEffect(() => {
        setFetchingList(true);
        dispatch(getForms(listFormKey));
    }, [])

    useEffect(() => {
        if (!_.isEmpty(tradeAlertList) && fetchingList) {
            setFetchingList(false);
        }
    }, [tradeAlertList])

    useEffect(() => {
        if (!_.isEmpty(listForm)) {
            dispatch(listAlertTrades({}, listFormKey));
        }
    }, [listForm]);

    const handleSearch = () => {
        dispatch(listAlertTrades({}, listFormKey));
    }

    return (
        <div style={{ position: 'relative', paddingBottom: '0px' }}> {/* Added padding-bottom */}
            <Listing
                headers={headers}
                data={listData}
                onSearch={handleSearch}
                meta={meta}
                fetchingList={fetchingList}
            />
        </div>
    );
};

export default AlertTrade;